module.exports = {
  businessUnits: {
    FR: {
      language: 'fr',
      country: 'FR',
      filter: ['FRA'],
      iframe: false,
      paths: { jobOffer: 'offre-emploi', apply: 'postuler', browse: 'parcourir' },
      links: {
        apple_store: `https://apps.apple.com/fr/app/iziwork-offres-demploi/id1446760096?l=fr&ls=1`,
        google_store: `https://play.google.com/store/apps/details?id=abeka.iziwork&hl=fr&gl=fr`,
      },
      currency: 'EUR',
      distanceUnit: 'km',
    },
    IT: {
      language: 'it',
      country: 'IT',
      filter: ['ITA'],
      iframe: false,
      paths: { jobOffer: 'offerta-lavoro', apply: 'candidati', browse: 'cerca' },
      links: {
        apple_store: `https://apps.apple.com/it/app/iziwork-offres-demploi/id1446760096?l=it&ls=1`,
        google_store: `https://play.google.com/store/apps/details?id=abeka.iziwork&hl=it&gl=it`,
      },
      currency: 'EUR',
      distanceUnit: 'km',
    },
    PPS: {
      language: 'en',
      country: 'US',
      filter: ['USA'],
      iframe: true,
      paths: { jobOffer: 'job-offer', apply: 'apply', browse: 'browse' },
      links: {
        apple_store: `https://apps.apple.com/en/app`,
        google_store: `https://play.google.com/store/apps/details`,
      },
      currency: 'USD',
      distanceUnit: 'mi',
    },
    PS: {
      language: 'en',
      country: 'US',
      filter: ['USA'],
      iframe: true,
      paths: { jobOffer: 'job-offer', apply: 'apply', browse: 'browse' },
      links: {
        apple_store: `https://apps.apple.com/en/app`,
        google_store: `https://play.google.com/store/apps/details`,
      },
      currency: 'USD',
      distanceUnit: 'mi',
    },
    PSTF: {
      language: 'en',
      country: 'US',
      filter: ['USA'],
      iframe: true,
      paths: { jobOffer: 'job-offer', apply: 'apply', browse: 'browse' },
      links: {
        apple_store: `https://apps.apple.com/en/app`,
        google_store: `https://play.google.com/store/apps/details`,
      },
      currency: 'USD',
      distanceUnit: 'mi',
    },
    ST: {
      language: 'en',
      country: 'US',
      filter: ['USA'],
      iframe: true,
      paths: { jobOffer: 'job-offer', apply: 'apply', browse: 'browse' },
      links: {
        apple_store: `https://apps.apple.com/en/app`,
        google_store: `https://play.google.com/store/apps/details`,
      },
      currency: 'USD',
      distanceUnit: 'mi',
    },
  },
};
